import React from "react";
import { initials, contrastText } from "@/lib/format";

export function PersonBadge({ person, size = 36, selected = false, dimmed = false, onClick, testId, label, count = 0, onCountClick, countTestId }) {
  const bg = person.color || "#64748B";
  const clickable = typeof onClick === "function";
  const Tag = clickable ? "button" : "span";
  return (
    <span className="relative inline-flex shrink-0">
      <Tag
        type={clickable ? "button" : undefined}
        onClick={onClick}
        data-testid={testId}
        title={person.name}
        className={`relative inline-flex shrink-0 items-center justify-center rounded-full font-semibold transition-transform duration-150 ${
          clickable ? "active:scale-90 cursor-pointer" : "cursor-default"
        } ${selected ? "ring-2 ring-offset-2 ring-offset-[var(--gz-card)]" : ""} ${
          dimmed ? "opacity-35" : "opacity-100"
        }`}
        style={{
          width: size,
          height: size,
          background: bg,
          color: contrastText(bg),
          boxShadow: selected ? `0 0 0 2px ${bg}` : "none",
        }}
      >
        <span style={{ fontSize: size * 0.36 }}>{label || initials(person.name)}</span>
      </Tag>
      {count > 0 && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onCountClick && onCountClick(e);
          }}
          data-testid={countTestId}
          aria-label="Remove one unit"
          className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 grid place-items-center rounded-full bg-[var(--gz-primary)] text-white text-[10px] font-bold leading-none ring-2 ring-[var(--gz-card)] active:scale-90 transition-transform"
        >
          &times;{count}
        </button>
      )}
    </span>
  );
}

export function PersonDot({ color, size = 10 }) {
  return (
    <span
      className="inline-block rounded-full"
      style={{ width: size, height: size, background: color || "#64748B" }}
    />
  );
}
